'use client';

import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { useWizardContext } from '../../contexts';
import { useEvento } from '@/store/evento/evento';
import ENVS from '@/app/api/config/env';
import type { Gateway } from '@/schemas/checkout.schema';

export function SeleccionarGateway() {
    const { next } = useWizardContext();
    const { set: setGateway } = useEvento.use.gateway();
    const allariaEnabled = ENVS.ALLARIA.ENABLED;

    const calledRef = useRef(false);

    useEffect(() => {
        if (calledRef.current) return;
        calledRef.current = true;

        if (!allariaEnabled) {
            setGateway('mercadopago');
            next();
        }
    }, [allariaEnabled, setGateway, next]);

    if (!allariaEnabled) return null;

    const handleSelect = (gateway: Gateway) => {
        setGateway(gateway);
        next();
    };

    return (
        <section className="space-y-8 py-6 text-white">
            <div className="text-center space-y-1">
                <h2 className="text-2xl font-bold tracking-tight">¿Cómo querés pagar?</h2>
                <p className="text-sm text-white/60">Elegí tu medio de pago preferido</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
                <button
                    type="button"
                    onClick={() => handleSelect('mercadopago')}
                    className="rounded-xl border-2 border-slate-200 bg-white px-8 py-10 transition-colors duration-150 hover:border-sky-400 hover:bg-sky-50 focus:outline-none focus:border-sky-500 flex items-center justify-center min-h-[160px]"
                >
                    <Image
                        src="/mercadopago/logo.svg"
                        alt="Mercado Pago"
                        width={240}
                        height={96}
                        className="h-20 w-auto object-contain"
                    />
                </button>

                <button
                    type="button"
                    onClick={() => handleSelect('allaria')}
                    className="rounded-xl border-2 border-slate-200 bg-white px-8 py-10 transition-colors duration-150 hover:border-blue-900 hover:bg-blue-50 focus:outline-none focus:border-blue-900 flex items-center justify-center min-h-[160px]"
                >
                    <Image
                        src="/allaria/logo.svg"
                        alt="Allaria+"
                        width={280}
                        height={80}
                        className="h-16 w-auto object-contain"
                    />
                </button>
            </div>
        </section>
    );
}
